module.exports = __webpack_public_path__ + "static/media/upgrade.2ba65a97.svg";